import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next'
import './LangSelection.css'
import { ReactComponent as FlagCZ } from './svg/cz.svg'
import { ReactComponent as FlagDE } from './svg/de.svg'

const LangSelection = ({}) => {
    const { t, i18n } = useTranslation()


    return (
        <>
            {i18n.language !== 'cs' && <a title={t('Přepnout jazyk na Češtinu')}><FlagCZ className="flag" onClick={() => i18n.changeLanguage('cs')}/></a>}
            {i18n.language !== 'de' && <a title={t('Přepnout jazyk na Němčinu')}><FlagDE className="flag" onClick={() => i18n.changeLanguage('de')}/></a>}
        </>
    );
}

export default LangSelection;
